import React from 'react';
import { Spinner } from 'react-bootstrap';

const Loading = ({ classExtra }) => {
    return (
        <div className={`${classExtra} d-flex w-100 justify-content-center`} >
            <Spinner animation='border' role='status'>
                <span className='sr-only'>Loading...</span>
            </Spinner>
        </div>
    );
};

export default Loading;
